import script from "./ExclusionGroupTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusionGroupTable.vue?vue&type=script&setup=true&lang=js"

import "./ExclusionGroupTable.vue?vue&type=style&index=0&id=b0e85356&lang=css"

const __exports__ = script;

export default __exports__